import React from "react"
import PropTypes from "prop-types"

const RelatedPostItem = (props) => {
  const trackClick = (e) => {
    props.trackEvent("Clicked Related Article", {
      article: this.props.articleSlug || "",
      relatedArticleSlug: this.props.slug,
      relatedArticleTitle: this.props.title,
    })
  }
  const styles = {
    backgroundImage: `url(${props.image})`,
  }
  return (
    <li className="related-post-item">
      <a href={props.slug} onClick={trackClick}>
        <div className="related-post__image" style={styles} />
        <div
          className="post-title"
          dangerouslySetInnerHTML={{ __html: props.title }}
        />
      </a>
    </li>
  )
}

RelatedPostItem.propTypes = {
  trackEvent: PropTypes.func,
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
}

export default RelatedPostItem
